export default {
  // 自定义后台数据
  custom_backstage: {
    customApp: '自定义应用',
    expertsService: '专家定制服务',
    selectAppTemplate: '选择应用模版',
    creatNewApp: '创建新的应用',
    juhe: '聚合表',
    app: '应用',
    module: '模块',
    myApp: '我的应用',
    uploadApp: '上传应用',
    noNameApp: '未命名应用',
    editIcon: '编辑图标',
    appName: '应用名称',
    moduleName: '模块名称',
    moduleType: '模块类型',
    creatModule: '创建模块',
    newBuildModule: '新建模块',
    editModule: '编辑模块',
    creatApp: '创建应用',
    editApp: '编辑应用',
    name: '名称',
    moduleIcon: '模块图标',
    creater: '创建人',
    createTime: '创建时间',
    nameMustfill: '名称必填',
    modifyPer: '修改人',
    modifyTime: '修改时间',
    transfer: '转移',
    transferTo: '转移给',
    transferToShare: '转移后共享给当前数据分析负责人',
    transferAfter: '将当前数据的负责人转移给其他负责人? 转移成功后，改操作将无法恢复',
    selectTransferPer: '请选择转移人员',
    transferComplete: '转移成功',
    rongjiuDelDataIsGoon: '此操作将永久删除该数据, 是否继续?',
    juheName: '聚合表名称',
    dataSource: '数据源',
    nodataRightadd: '暂无数据，请从右侧添加～',
    theDataSource: '数据来源',
    rowTable: '行表头',
    add: '添加',
    guanlianField: '关联字段',
    columnTable: '列表头',
    tongjizhibiao: '统计指标',
    screenContion: '筛选条件',
    visibility: '可见性',
    kexuanbumen: '可选择部门、成员、角色, 支持多选',
    run: '运 行',
    oneTabledata: '单表数据',
    moreTableGuanlian: '多表关联',
    dataTable: '数据表',
    selectGuanlianData: '请选择关联数据',
    jianyanInfo_1: '数据来源不能为空',
    jianyanInfo_2: '行表头、列表头、统计指标中, 至少有一个主表字段',
    jianyanInfo_3: '行表头不能为空',
    jianyanInfo_4: '统计指标不能为空',
    jianyanInfo_5: '聚合表名称不能为空',
    jianyanInfo_6: '统计指标名称不能为空',
    jianyanInfo_7: '统计指标公式不能为空',
    jianyanInfo_8: '统计指标名称不能重复',
    jianyanInfo_9: '数据还未保存,是否退出?',
    jianyanInfo_10: '数据表最多选择5个',
    jianyanInfo_11: '该数据已存在',
    jianyanInfo_12: '数据表不能为空',
    jianyanInfo_13: '字段关联不能为空',
    jianyanInfo_14: '此操作将重置之前设置的参数, 是否继续?',
    appNameNotEmpty: '应用名称不能为空',
    uploaderNotEmpty: '上传人不能为空',
    onePicUpload: '请至少上传一张应用图片',
    descNotEmpty: '描述不能为空',
    priceNotEmpty: '价格不能为空',
    formatError: '格式错误',
    accountNotEmpty: '账号不能为空',
    appDetail: '应用详情',
    baseInfo: '基本信息',
    Industry: '所属行业',
    appType: '应用分类',
    uploader: '上传人',
    appScreenshot: '应用截图',
    uploadPic8: '请上传该应用的Web端和App端截图, 总共不超过8张',
    functionInfo: '功能介绍',
    appDesc: '应用描述',
    payInfo: '收费信息',
    ifPay: '是否收费',
    Price: '价格',
    receivingAccount: '收款账号',
    payInfoToTeamface:
      '每一笔付款都需要经过7天的资金审核期, 结束后款项会自动打入账号; 收款账号非常重要,请谨慎填写;如填写有误, 请及时联系客服人员',
    penddingShenhe: '提交成功, 请等待系统审核!',
    seeeProgress: '您可以在“应用中心—我的上传”中查看进度',
    free: '免费',
    pay: '付费',
    alipay: '支付宝',
    wechat: '微信',
    oneInputOneOption: '每行可输入一个选项',
    moveModule: '移动模块',
    suoshuApp: '所属应用',
    pleaseInputDelModuleName: '请输入需删除的模块名称',
    appHaveModule: '应用下存在模块,请先删除模块',
    sureDelApp: '删除后将不可恢复,确定要删除该应用吗?',
    moduleNameInputError: '模块名称填写错误',
    pageLayout: '页面布局',
    approvalProcess: '审批流程',
    globalSettings: '全局设置',
    moduleRelease: '模块发布',
    noAuthOperateApprovalProcess: '无权操作审批流程',
    pleaseSaveCustomLayout: '请先保存自定义布局',
    highContionSet: '高级条件设置',
    before: '以前',
    after: '以后',
    highContion: '高级条件',
    addFilterContion: '添加过滤条件',
    illegalFormula: '公式不合法',
    pleaseInputFormula: '请正确填写公式',
    contionSetWarning: '条件设置有误',
    contionFormula: '条件公式',
    contionMax2: '条件大于等于2条才能使用高级条件',
    highContionInfo1: '注意：1. 不允许出现不存在的序号;',
    highContionInfo2: '例：1 and 2 and 3 and 4...',
    highContionInfo3: '2. 有and和or，必须要有括号;',
    highContionInfo4: '例：1 and 2 or 3 、(1 and 2) and 3 or 4;',
    highContionInfo5: '(1 and 2) or (3 or 4) and (5 or 6);',
    highContionInfo6: '(1 and 2 or 3) and 4',
    highContionInfo7: '3. 一个括号不能同时出现and 和or;',
    highContionInfo8: '例：(1 and 2 or 3 and 4; 括号都是成对出现的;',
    highContionInfo9: '可以使用 OR,AND,NOT和英文括号将上列条件组成逻辑关系;',
    highContionInfo10: '例如：(1 AND 2) OR 3 表示第一和第二个条件与关系后，再和第三个条件或运算;',
    selectInsetField: '选择插入字段',
    selectSubformName: '选择子表名称',
    selectFieldName: '选择字段名称',
    selectSubModule: '选择子模块',
    fun: '函数',
    AllFunType: '所有函数类别',
    insertFun: '插入所选函数',
    insertYunsuanfu: '插入运算符',
    operator: '运算符',
    manzuContionShowThisMsg: '在满足条件公式下显示此消息',
    gongshiErrorOnlyone: '公式有误，请至少选择插入一个函数',
    formulaDontUseTihua: '公式内容不能包含【"】符号，请用【\'】替换',
    fieldNothereFormulaSetting: '字段不存在，请重新调整公式设置',
    CdtFormulaRequired: '条件公式必填',
    tipsTextRequired: '提示文字必填',
    ordinalParameter: '序号参数',
    submitCheck: '提交校验',
    formula: '简单公式',
    functionformula: '函数公式',
    citeformula: '引用公式',
    seniorformula: '高级公式',
    fixedValue: '固定值',
    sequenceNumber: '顺序号',
    sequenceNumberRequired: '顺序号为必填项',
    identiferInfo1: '1. 固定值：输入文字或字母皆可',
    identiferInfo2: '2. 年月日：{yyyy} =年; {MM} =月；{dd} =日',
    identiferInfo3: '3. 顺序号：{0001}=顺序号。可定义数字位数及起始数字',
    identiferInfo4: '例如{00002}， 表示顺序号为5位数, 下一编号从2开始自动计算',
    chanceStyle: '更换样式',
    systemInfo: '系统信息',
    mobilePhone: '手机',
    wenben: '文本',
    personnel: '人员',
    currentPersonnel: '当前成员',
    text: '单行文本',
    textarea: '多行文本',
    multitext: '富文本',
    picklist: '下拉选项',
    phone: '电话',
    email: '电子邮箱',
    number: '数字',
    datetime: '日期/时间',
    attachment: '附件',
    url: '超链接',
    location: '定位',
    picture: '图片',
    multi: '复选框',
    mutlipicklist: '多级下拉',
    department: '部门',
    onlyDepartmentVisible: '仅所属部门可见',
    area: '省市区',
    identifier: '自动编号',
    serialnum: '流水号',
    reference: '关联关系',
    subform: '子表单',
    barcode: '条码',
    resumeanalysis: '简历解析',
    signature: '手写签名',
    changyongField: '常用字段',
    fieldComponent: '字段组件',
    baseField: '基础字段',
    seniorComponent: '高级类组件',
    highVersionComponent: '更高版本组件',
    businessComponent: '业务组件',
    carModel: '车型配置解析',
    queryPlatforms: '查询第三方平台',
    aiImageTextRecognition: 'AI图文识别',
    thisOperateDelSetIsgoon: '此操作将永久删除该组件及组件的属性设置?',
    thisOperateIsGoon: '是否继续?',
    warning: '警告',
    moduleChangeIsSave: '模块内容有更改, 是否需要保存?',
    fieldNameNotEmpty: '字段名称不能为空',
    moduleNameNotEmpty: '模块名称不能为空',
    moduleTypeNotEmpty: '模块类型不能为空',
    templateModule: '模版模块',
    pleaseInputTemplateName: '请输入需删除的模板名称',
    customTemplate: '自定义模版',
    projectTemplate: '协作模版',
    taskTemplate: '任务模版',
    platformTemplate: '平台模版',
    moduleSet: '模块设置',
    detailsControl: '详情控件',
    terminal: '终端',
    setAppearance: '设置外观',
    themeStyle: '主题样式',
    attributeStyle: '属性样式',
    holisticStyle: '整体样式',
    pageBackground: '页面背景',
    tableHeadStyle: '表头样式',
    headBackground: '头部背景',
    mainTitle: '主标题',
    moduleDesc: '模块描述',
    descText: '描述文字',
    contentStyle: '内容样式',
    contentBackground: '内容背景色',
    submitStyle: '提交区样式',
    submitBackground: '提交背景',
    submitStyleNew: '提交样式',
    submitFeedback: '提交反馈',
    buttonColor: '按钮颜色',
    selectColor: '选择颜色',
    buttonShow: '按钮显示',
    singleButton: '单按钮',
    dobuleButton: '双按钮',
    buttonText: '按钮文字',
    buttonWidth: '按钮宽度',
    buttonPosition: '按钮位置',
    moduleAppearance: '模块外观',
    columnsSet: '分栏设置',
    columnsName: '分栏名称',
    showHidden: '显示/隐藏',
    defaultHiddenColumn: '默认收起分栏',
    addEditHiddenCloumnName: '在新增／编辑页隐藏分栏名称',
    addEditHiddenCloumn: '在新增／编辑页隐藏',
    detailsHiddenCloumn: '在详情页隐藏',
    fieldSet: '字段设置',
    fieldName: '字段名称',
    tipsText: '提示文字',
    default: '默认值',
    mappingField: '映射字段',
    set: '设置',
    type: '类型',
    optionContent: '选项内容',
    batchAdd: '批量添加',
    digit: '位数',
    decimalDigit: '小数位数',
    fengefu: '分隔符',
    inputRange: '输入范围',
    dontInputUnlimited: '不填代表无限制',
    numberControl: '数量控制',
    noLimit: '不限制',
    limit: '限制',
    sizeRequire: '尺寸要求',
    yiji: '一级',
    erji: '二级',
    sanji: '三级',
    twoPulldown: '二级下拉',
    threePulldown: '三级下拉',
    oneOption: '一级选项',
    twoOption: '二级选项',
    threeOption: '三级选项',
    addOption: '添加选项',
    oneDefault: '一级默认值',
    twoDefault: '二级默认值',
    threeDefault: '三级默认值',
    chooseRange: '可选范围',
    setFormula: '设置公式',
    dataType: '数据类型',
    returnType: '返回类型',
    jingquedu: '精确度',
    bianhaoResult: '编号结果',
    setBianhaoRule: '设置编号规则',
    referenceModule: '关联模块',
    referenceField: '关联字段',
    buttonConfig: '按钮配置',
    listSearchField: '列表搜索字段',
    scan: '扫码',
    barcordComponent: '该功能仅对平台移动端有效且关联模块必须保存有条码组件',
    scanInput: '扫码输入',
    onlyOneSetScan: '只允许设置一个扫码功能',
    setScreenContion: '设置关联筛选条件',
    addScreenContion: '添加筛选条件',
    subformStyle: '子表单样式',
    table: '表格',
    card: '卡片',
    subformField: '子表单字段',
    selectFIeldAddToTable: '选择字段添加到子表单',
    subfromDefalut: '子表单默认值',
    ifEditShowDefaultSet: '是否编辑页无值显示默认设置',
    addressLocation: '地址位置',
    defaultLocation: '默认当前位置',
    serialnumFule: '流水号规则',
    field: '字段',
    date: '日期',
    addFule: '添加规则',
    fieldWidth: '字段宽度',
    singleColumn: '单列',
    doubleColumn: '双列',
    threeCloumn: '三列',
    fourCloumn: '四列',
    fieldStructure: '字段结构',
    leftRightLayout: '左右布局',
    topBottomLayout: '上下布局',
    fieldControl: '字段控制',
    redayOnly: '只读',
    noControl: '不控制',
    fieldAuth: '字段权限',
    addShow: '新增时显示',
    editShow: '编辑时显示',
    detailShow: '详情时显示',
    radio: '单选',
    multiple: '多选',
    phoneNumber: '手机号码',
    domestic11: '国内11位',
    unlimited: '不限',
    ProjectMembers: '项目成员',
    currentDepartment: '当前部门',
    provinceCity: '省市',
    province: '省',
    city: '市',
    area1: '区',
    currentTime: '当前时间',
    zhidingTime: '指定时间',
    checkedRepeat: '查重',
    donotEnablecheckdRepeat: '不启用查重',
    enablecheckdRepeat1: '启用查重，允许保存数据',
    enablecheckdRepeat2: '启用查重，不允许保存数据',
    noOpacity: '不透明',
    auto: '自适应',
    forTableWidth: '与表单同宽',
    internationalCode: '国际编码',
    customCode: '自定义编码',
    option: '选项',
    newOption: '新选项',
    oneNewOption: '一级新选项',
    twoNewOption: '二级新选项',
    threeNewOption: '三级新选项',
    sureDelCutomField: '确定删除自定义字段(不可恢复)?',
    listLayout: '列表布局',
    max3RowData: '最多只能添加3行数据',
    max3ColumnData: '最多只能添加3列数据',
    biaochunPageNotSave: '标准页面布局未保存',
    saveListLayoutSuccess: '保存列表布局成功',
    saveFail: '保存失败',
    outLinkExtendlist: '外链扩展列表',
    extendNameRequire: '扩展名（必填）',
    extendValueRequire: '扩展值（必填）',
    extendNameRequire1: '拓展名必须填写',
    extendValueRequire1: '拓展值必须填写',
    jiexiAfterAutoInput: '解析后抽取字段自动填充到自定义字段中',
    customField: '自定义字段',
    jiexiField: '解析字段',
    valueDuiyingTo: '的值对应为',
    cutomJiexieFieldNotEmpty: '自定义字段和解析字段不能为空',
    formulaNew: '公式',
    addPage: '新增页面',
    AppListLayout: '移动端布局',
    webform: 'web表单',
    biaozhunPage: '标准页面',
    subPage: '子页面',
    liushuiRuleNotEmpty: '流水号规则不能为空',
    oneOtionValue: '至少需要存在一个选项值',
    bianhaoRuleNotEmpty: '编号规则不能为空',
    computeNotEmpty: '计算公式不能为空',
    thisOprateDelPageIsGoon: '此操作将永久删除该页面,是否继续?',
    saevFailNetworkClickSyn:
      '保存页面布局时存在网络连接失败信息, 为保证页面布局正常使用,请点击“同步”按钮继续操作',
    synSuccess: '同步成功',
    syn: '同步',
    modulePushSuccess: '模块发布成功, 还可以继续创建模块哦~',
    goonCreate: '继续创建',
    firstWebform: '第一个web表单',
    webformNameNotEmpty: '名称不能为空',
    webformPwdNotEmpty: '密码不能为空',
    webformPwd6: '表单密码长度6位',
    validationFieldNotEmpty: '验证字段不能为空',
    fieldNotEmpty: '字段不能为空',
    sameWebformName: '存在相同的表单名称, 是否为相同的活动?',
    approvalSaveUse: '保存并使用',
    approvalReset: '重置',
    approvalRevoke: '撤销',
    approvalNodeAttr: '节点属性',
    approvalSelectNode: '请选择节点',
    approvalNodeName: '节点名称',
    approvalInput10: '只能输入10个字符',
    approvalBrancheCondtion: '分支条件',
    approvalSetBranche: '设置分支条件',
    approvalPerType: '审批人类型',
    approvalSelectPer: '选择审批人',
    approvalPerStop: '终止审批人',
    approvalPerStopAfter: '只要终止审批人审批过后, 审批单就不再继续往上流转',
    approvalMode: '审批方式',
    approvalYici: '依次审批',
    approvalHuanjieYici: '本环节内审批人依次审批',
    approvalHuiqian: '会签',
    approvalHuiqianInfo: '所有审批人同时收到审批, 且所有人需同意方可算审批通过',
    approvalHuoqian: '或签',
    approvalHuoqianInfo: '所有审批人同时收到审批, 只需一个人审批通过或拒绝即可',
    approvalStarePer: '发起人的',
    approvalDibu: '待审递补',
    approvalzKongque: '若该审批人空缺, 由其在通讯录中的上级部门负责人代审批',
    approvalSet: '审批设置',
    approvalMustSingtrue: '审批通过时必须手写签名',
    approvalSingtrue: '审批通过时可手写签名',
    approvalcaosong: '选择抄送人',
    approvalRejectMode: '驳回方式',
    approvalKefuxuan: '审批人可以根据审批内容选择驳回方式, 可复选',
    approvalBohui1: '驳回给上一节点审批人',
    approvalBohui2: '驳回到发起人',
    approvalBohui3: '驳回到指定节点',
    approvalBohui4: '驳回并结束',
    approvalCaosongMode: '抄送方式',
    approvalPassCaosong: '审批通过抄送',
    approvalRejectCaosong: '审批驳回抄送',
    approvalEditField: '当前环节审批人与抄送人能够看见的字段, 审批人能够编辑的字段',
    approvalIsshow: '可见',
    approvalProcessAttr: '流程属性',
    approvalApplicant: '申请人',
    approvalProcessMode: '流程方式',
    approvalFixedProcess: '固定流程',
    approvalAnzhao: '按照设定好的流程来执行审批',
    approvalFreeProcess: '自由流程',
    approvalNotSetProcess: '不需要设定流程, 由前台操作人来决定审批流转流程',
    approvalFaqiShow: '发起人可见',
    approvalFaqiNotShow: '发起人不可见',
    approvalProcessRemind: '流程提醒',
    approvalEveryNodeRemind: '每个节点审批通过都提醒发起人',
    approvalAllowCehui: '允许发起人撤回审批',
    approvalAllowCehui1: '是否允许发起人在审批单未被审批之前撤回',
    approvalAllowZhuanjiao: '允许审批人转交审批',
    approvalAllowCaosong1: '允许发起人抄送审批',
    approvalAllowCaosong2: '允许审批人抄送审批',
    approvalAllowCaosong3: '允许抄送人抄送审批',
    noSkipHistoryNode: '不跳过历史节点',
    noSkipHistoryNodeRemark: '驳回到的环节通过后重新依次审批',
    skipHistoryNode: '跳过历史节点',
    skipHistoryNodeRemark:
      '驳回到的环节通过后直接返回本环节；例：1,2,3三个节点，3驳回至1，如自动跳过，1完成后跳过2直接到3',
    approvalerRepeat: '审批人去重',
    approvalDelProcess: '删除流程',
    approvalLiuruNode: '任意条件均可流入该节点',
    approvalLiuruNode1: '满足指定条件才可流入该节点',
    approvalSingle: '单人审批',
    approvalMore: '多人审批',
    approvalDeparmentSingle: '部门负责人-单级',
    approvalDeparmentMore: '部门负责人-多级',
    approvalZhidingRole: '指定角色',
    approvalMy: '发起人自己',
    approvalOneDeparment: '第一级部门负责人',
    approvalTwoDeparment: '第二级部门负责人',
    approvalThreeDeparment: '第三级部门负责人',
    approvalFourDeparment: '第四级部门负责人',
    approvalDontAutoRepeat: '不启用自动去重',
    approvalDontAutoRepeat1: '同一个审批人在流程中多次出现, 自动去重',
    approvalDontAutoRepeat2: '同一个审批人在流程中连续出现, 自动去重',
    approvalProcessStartNode: '流程开始节点',
    approvalProcessEndNode: '流程结束节点',
    approvalNewNode: '新节点',
    approvalAddNode: '添加节点',
    approvalNodeNameNotEmpty: '节点名称不能为空',
    approvalPleaseSelectPer: '请选择审批人',
    approvalSaveSuccess: '保存审批流程成功',
    approvalSaveTakeEffectSuccess: '保存审批流程成功且已生效',
    approvalCreateModuleThen: '请先创建模块再创建流程',
    approvalInitNotDel: '初始化的流程节点不能删除',
    approvalResetIsOk:
      '重置后流程会恢复初始化样式,所有已经设置好的规则都将会被还原; 你确定要重置吗?',
    approvalContonMax2: '条件大于两个才能设置高级条件',
    approvalDelIsGoon: '此操作将永久删除该流程, 是否继续?',
    approvalDelSuccess: '删除流程成功',
    approvalDelFail: '删除流程失败',
    pleaseSelectMatrix: '请选择矩阵',
    pleaseSelectJobPos: '请选择矩阵下的岗位',
    pleaseSelectDepCompoment: '请选择矩阵对应的部门组件',
    unsetMatrix: '未设置矩阵',
    unsetJopPos: '未设置岗位',
    to: '到',
    fenlanHaveFuzeren: '当前分栏存在【负责人】字段, 将其移动到其他分栏后才可删除分栏?',
    selFenlanMoveEnable: '通过删除分栏, 将会把分栏内的字段移除到未使用字段中?',
    newAddColumns: '新增分栏',
    clickSigntrue: '点击签名',
    notSaveIsSaveLayout: '布局未保存, 是否保存布局?',
    columns: '分栏',
    unusedFields: '未使用字段',
    customColor: '自定义颜色',
    color: '颜色',
    textColorSet: '文本颜色设置',
    selectIcon: '选择图标',
    uploadIcon: '上传图标',
    max10: '最大10',
    max100: '最大100',
    plsaseSelectComponents: '请从左侧拖入字段～',
    submitSuccess: '提交成功',
    textDesc: '文本描述',
    splitLine: '分割线',
    button: '按钮',
    pictureCarousel: '图片轮播',
    videoShow: '视频展示',
    staticMap: '静态地图',
    timer: '计时器',
    SignIn: '签到',
    fullname: '姓名',
    form: '表单',
    saveAndGoback: '保存返回',
    listFieldWidth: '列表宽度',
    pleaseSelectField: '请选择字段',
    content: '内容',
    buttonStyle: '按钮样式',
    defaultWebform: '默认',
    customWebform: '自定义',
    textSize: '文字大小',
    buttonIcon: '按钮图标',
    buttonFillet: '按钮圆角',
    buttonHeight: '按钮高度',
    autoText: '适应文字',
    uploadButtonStyle: '上传按钮样式',
    size: '尺寸',
    proposalWidthHeight: '建议宽高 ＜375像素x80像素',
    clickEvent: '点击事件',
    selectType: '选择类型',
    lickAddress: '链接地址',
    selectLickAddress: '请输入链接地址',
    sendEmali: '发邮件',
    linetype: '线型',
    linewidth: '线宽',
    linecolor: '线条颜色',
    clickUpload: '点击上传',
    carouselCount: '轮播数量',
    lickAddressDesc: '链接地址/描述',
    inputDescContent: '请输入描述内容',
    baseSet: '基础设置',
    carouselSpeed: '轮播速度',
    pictrueHeight: '图片高度',
    videoAddress: '视频地址',
    supportTYAT: '支持腾讯视频、优酷、爱奇艺、土豆',
    outMediaPasteInput: '请将外部媒体地址粘贴至输入框',
    showAddress: '显示地点',
    inputTargetAddress: '输入目标地址',
    timerType: '计时器类型',
    inmapShowBiaoji: '在地图标记点上显示信息框',
    proposalPic750450: '建议图片尺寸为750*450',
    jishi: '计时',
    daojishi: '倒计时',
    intoValueSecond: '初始值(秒)',
    shiwFormat: '显示格式',
    arrivalDate: '到达日期',
    fromField: '表单字段',
    selectFieldAddToFrom: '选择字段添加到表单',
    jumpLink: '跳转链接',
    title: '标题',
    thankInputFeedback: '我们已收到您的反馈, 感谢填写',
    formSet: '表单设置',
    formName: '表单名称',
    onlyPcVisit: '仅PC端访问生效',
    fieldStyle: '字段样式',
    contetnBg: '内容背景',
    titleStyle: '标题样式',
    inputAuth: '填写权限',
    set6Pwd: '设置6位密码',
    linkExpand: '链接拓展',
    linkExpandInfo: '对同一个表单赋予扩展属性值使该表单拥有多个链接地址, 用于标识不同数据',
    linkExpandInfo2:
      '对同一个表单赋予扩展属性值使该表单拥有多个链接地址, 用来标识收集到的不同数据的来源渠道。',
    expandOutlink: '扩展外链',
    expandOutlinkList: '扩展外链列表',
    shareSet: '分享设置',
    shareSetInfo: '分享设置信息用于分享表单时显示的样式内容, 用于分享到第三方平台',
    whetherSignin: '是否签到',
    enable: '启用',
    close: '关闭',
    activityTheme: '活动主题',
    signinButton: '签到按钮',
    signinTypeface: '签到字体',
    fypefaceColor: '字体颜色',
    formStyle: '表单样式',
    signinbg: '签到背景',
    restoreDefault: '恢复默认',
    use375667: '建议使用375*667尺寸的图片',
    validationField: '验证字段',
    signinRestriction: '签到限制',
    openSignin: '允许开放式签到',
    submitSuccessTips: '提交成功提示',
    callUp: '拨打电话',
    sendMessage: '发短信',
    solidLine: '实线',
    dottedLine: '虚线',
    dotMarking: '点划线',
    doubleSolidLine: '双实线',
    max4Pic: '最多添加4张图片',
    max5Pic: '最多添加5张图片',
    inputTabge50to1000: '输入范围：50-1000',
    inputTabge250to1000: '输入范围：250-1000',
    addAddress: '添加地址',
    addForm: '新建表单',
    visitAuth: '访问权限',
    release: '发布',
    sureDelWebform: '确定要删除该web表单吗?',
    sureReleaseWebform: '确定要发布该web表单吗?',
    sureCloseWebform: '确定要关闭该web表单吗?',
    releaseSuccess: '发布成功',
    closeSuccess: '关闭成功',
    copiedToClipboard: '已复制至剪切板',
    column: '栏目',
    noSelectFieldNoAttr: '没有选择字段或该字段没有属性',
    fieldEnglishName: '字段英文名称',
    locking: '锁定',
    WholeCompany: '全机构',
    teshuontrol: '特殊控制',
    allowRemove: '允许移除',
    allowMove: '允许移动',
    allowDelete: '允许删除',
    customOption: '自定义选项',
    referenceTasktTag: '关联协作任务标签数据',
    referenceProjectTag: '关联本项目标签数据',
    referenceCommodity: '关联商品分类数据',
    projectAndCustomData: '项目和自定义数据',
    networkFialAgainCheck: '网络连接失败, 请检查您的网络重新访问',
    multilingualSettings: '多语言设置',
    Languages: '语种',
    addMoreLanguages: '添加语种',
    backgroundMusic: '背景音乐',
    sms: '短信验证',
    smsTip: '使用该功能前请先在【系统管理】-【短信管理】中进行短信平台账户绑定。',
    needSms: '需要短信验证',
    code_error: '请输入验证码',
    getcode: '获取验证码',
    appAdminer: '应用管理员',
    appAdminerSet: '应用管理员设置',
    appHomepage: '应用首页',
    quoteReport: '引用数据分析',
    delquoteReport: '删除引用数据分析',
    addDescription: '添加说明',
    fromTamplateCreate: '从模板创建',
    fromExcelImport: '从Excel导入',
    sureDelModule: '确定要删除模块',
    delModuleTips: '?删除后该模块将不可恢复且模块内的数据也同时被删除',
    dontWantToReport: '没有想要的数据分析?',
    gotoCreate: '去创建',
    appDescFirstShow: '应用说明，用户第一次访问应用会弹出该说明',
    excelImportInfo1: '1、支持 20MB 以内的xlsx格式文件，最多允许上传10000条;',
    excelImportInfo2: '2、目前不支持导入创建子表单、关联关系、自动编号、流水号等;',
    excelImportInfo3: '3、请将字段名称显示在第一行中，不能存在合并的单元格;',
    excelImportInfo4: '4、列子段数量不得超过200列;',
    importDataError: '导入数据失败，请查看已下载的错误日志',
    tamplatePreview: '模板预览',
    sampleTemplate: '示例模板',
    pleaseAddFile: '请添加文件',
    pleaseChooseReport: '请选择需要引用的数据分析',
    determineDelAppHomepage: '确定要删除该应用首页吗?',
    appHaveAppHomepage: '应用下存在应用首页，请先删除应用首页?',
    formDesign: '表单设计',
    listSetting: '列表设置',
    detailLayout: '详情布局',
    subpageNameMustfill: '子页面名称不能为空',
    subpageNameNotRepeat: '子页面名称不能重复，请修改后重新保存',
    fieldSetPayNotBallback: '字段支付功能已开启，但未设置对应回填字段',
    automationRules: '自动化规则',
    layoutTipsJudge1: '关联模块属性为空',
    layoutTipsJudge2: '关联字段属性为空',
    layoutTipsJudge3: '二级或三级至少添加一个选项',
    layoutTipsJudge4: '选项不能为空',
    layoutTipsJudge5: '选项不能重复',
    layoutTipsJudge6: '一个模块仅能使用一个工商信息查询',
    layoutTipsJudge7: '请至少选择一个对应字段',
    layoutTipsJudge8: '智能插件中身份证名称必填',
    approvalCheckRepeat: '审批查重',
    approvalCheckRepeat0: '审批查重设置',
    approvalCheckRepeat1: '审批查重设置(审批中数据查重)',
    approvalCheckRepeat2:
      '审批查重设置(用于审批中的数据进行查重，不允许再次提交相同条件审批中的数据（审批状态=审批中、待审批时作为校验数据）)',
    approvalCheckRepeat3: '查重规则条件',
    approvalCheckRepeat4: '设置查重规则条件',
    approvalCheckRepeat5: '可以使用 OR,AND,NOT和英文括号将上列条件组成逻辑关系;',
    approvalCheckRepeat6:
      '例如：(1 AND 2) OR 3 表示第一和第二个条件与关系后，再和第三个条件或运算;',
    approvalCheckRepeat7: '在符合查重条件后，显示此消息',
    approvalCheckRepeat8: '在满足条件公式时提交保存动作',
    preciseQuery: '精确查询',
    intervalDuplicateChecking: '区间查重',
    approvalContionShowInfo: '在符合查重条件后，显示此消息 必填',
    gobackJuheTable: '返回聚合表',
    computer: '电脑',
    rightShowValue: '在右边设置列表显示数值',
    allData: '全部数据',
    listValue: '列表数值',
    mobileTerminal: '移动端',
    moduleDataList: '模块数据列表',
    chooseShowFields: '选择显示字段',
    chooseReportCharts: '选择数据分析图',
    chooseVauleChart: '选择数值图表',
    listSetUpdate: '列表设置有更改，是否需保存?',
    subpageSetting: '子页面设置',
    delSubpage: '删除子页面',
    fromLeftDraggableField: '可从左侧拖拽添加字段～',
    subformFieldMustLeft: '子表单字段只能从左侧 "字段组件" 中拖入',
    subformNotDraggField: '子表单中不支持此组件，请添加其它组件',
    subformDontToMain: '子表单字段不能拖入主表中',
    appearanceSet: '外观设置',
    addColumn: '添加分栏',
    pleaseDraggToSubform: '请拖入名称对应的子表单中',
    draggableInAddFields: '（拖拽添加字段）',
    subpageName: '子页面名称',
    fieldDescription: '字段描述',
    digitalUnit: '数字单位',
    pleaseInputUnit: '请输入单位，如“个”',
    formluaMarkColor: '用于对公式值进行背景颜色标识',
    shibieType: '识别类型',
    shibieCallBackSet: '识别回填设置',
    callBackSet: '回填设置',
    callBackSetInfo1: '用于将查询到的信息自动回填填充到字段中，提高准确性和效率，选填',
    payFunction: '支付功能',
    payFunInfo1: '可以通过扫码进行微信支付和支付宝支付',
    payFunInfo2: '支付字段对应设置',
    payFunInfo3: '对应设置用于将支付反馈字段填充到自定义组件中显示',
    payFunInfo4: '请先至【后台】-【接口集成】-【第三方接口】-【支付接入】中开通支付功能',
    payFunInfo5:
      '已开启支付功能，一个模块内仅允许一个字段开启支付，如要开启当前字段，请先将原字段支付功能进行关闭',
    smartPlugIn: '智能插件',
    smartPlugInInfo:
      '使用该功能前至【接口集成】-【第三方平台】-【阿里云集成】中设置对应阿里云接口账户，无配置接口账户则该功能无效',
    shibieIDcard: '身份证识别',
    checkSet: '校验设置',
    checkSetInfo1: '用于校验姓名和身份证号是否匹配，必填',
    shoukuanInof1: '收款金额',
    shoukuanInof2: '收款方式',
    shoukuanInof3: '收款状态',
    shoukuanInof4: '收款时间',
    shoukuanInof5: '交易号',
    idCardMudtFill: '身份证名称必填',
    mustOnlyOneField: '请至少选择一个对应字段',
    chooseFormName: '选择表单名称',
    checkRepeatShowInfo1: '在符合条件公式后，显示此消息',
    checkRepeatShowInfo2: '不允许提交',
    checkRepeatShowInfo3: '允许提交，提示以上消息且支持选择是否继续保存',
    bianhaoRule: '编号规则',
    nameField: '名称字段',
    layout: '布局',
    businessComponey: '业务组件',
    clickComToLayout: '点击组件到布局中使用',
    addRemark: '添加备注',
    clickRightInputUrl: '点击在右侧设置输入URl链接',
    clickRightAddField: '点击在右侧设置添加显示字段',
    headerTitleSet: '头部标题设置',
    displayStyle: '显示风格',
    biaozhun: '标准',
    cardStyle: '卡片样式',
    showHeaderFiled: '显示头部字段',
    fieldShowStyle: '字段显示样式',
    upDown: '上下',
    letRight: '左右',
    allShowStyle: '整体显示样式',
    zuheShow: '组合显示',
    aloneShow: '单独显示',
    showField: '显示字段',
    more12Fields: '最多显示12个字段',
    showDesc: '显示描述',
    showDescInfo1: '描述字段为布局中的多行文本字段',
    addTagFields: '添加标签字段',
    tagFieldsinfo1: '标签字段为布局中的下拉选项（多选）字段',
    valueCountSet: '数值统计设置',
    lineCount: '单行数量',
    addGaojiFormula12: '添加高级公式字段，最多显示12个',
    tabSet: 'Tab页签设置',
    tabShowStyle: 'Tab展示样式',
    tab: '页签',
    biaoqian: '标签',
    tabWaiguan: '页签外观',
    style: '风格',
    tabPosition: 'Tab页签位置',
    tabContent: '页签内容',
    qianruPageSet: '嵌入页面设置',
    titleName: '标题栏名称',
    inputUrl: '输入URL',
    qianruUrlView: '嵌入URL预览',
    qianruUrlViedoPic: '可嵌入网页、视频、图片链接',
    showStyle: '展示的样式',
    defaultShow: '默认显示',
    timeListSet: '时间轴设置',
    sortFunction: '排序方式',
    defaultStyle: '默认样式',
    style1: '样式一',
    style2: '样式二',
    style3: '样式三',
    headerShow: '头部显示',
    detailsData: '详细资料',
    valueCount: '数值统计',
    carousel: '轮播图',
    carouselDescription: '点击在右侧设置轮播图',
    qianruPage: '嵌入页面',
    tabYeqian: 'Tab页签',
    StyleOne: '风格一',
    StyleTwo: '风格二',
    StyleThree: '风格三',
    StyleFour: '风格四',
    StyleFive: '风格五',
    layoutDetailJudge1: '请至少选择一个头部显示字段',
    layoutDetailJudge2: '请选择头部显示标签',
    layoutDetailJudge3: '请选择头部描述字段',
    layoutDetailJudge4: '嵌入页面URL不能为空',
    layoutDetailJudge5: '存在空页签布局，请删除后再保存',
    layoutDetailJudge6: '时间轴设置有误',
    layoutDetailJudge7: '数值统计字段不能为空',
    layoutDetailJudge8: '请选择时间轴字段',
    layoutDetailJudge9: '请输入嵌入网页的URL',
    layoutDetailJudge10: '嵌入网页的URL格式不正确',
    idCardCheck: '身份证号校验',
    idCard: '身份证号',
    moreLanguageSet: '多语言设置',
    dragpaneltouse: '拖动组件到面板使用',
    formpage: '表单页面',
    checkinpage: '签到页面',
    formfieldontherightside: '请在右侧“表单字段”添加',
    signinnow: '立即签到',
    signedupyet: '还没有报名？',
    signup: '去报名',
    namebackground: '名称底色',
    signinsettings: '签到设置',
    passwordaccess: '密码访问',
    password: '密码',
    published: '已发布',
    unpublished: '未发布',
    extendName: '扩展名',
    link: '链接',
    unnamedform: '未命名表单',
    workFlowTrigger: '在数据自动新建后（新建与更新执行操作中的新建数据触发）',
    scheduleContent: '日程内容',
    referneceDefTriggerData: '关联：默认关联引用当前触发新建日程数据',
    everyYear: '每年',
    injionMemberNotEmpty: '参与人不能为空',
    starttimeLessEndtime: '开始时间不能大于结束时间',
    remindtimeInputJudge: '提醒时间请输入正整数',
    starttimeIsError: '开始时间填写有误',
    baseTemplate: '基础模版',
    delCustomTemplate: '是否删除该自定义模板?',
    formatCheck: '格式校验',
    picTextShitbie: '图文识别',
    saveBtn: '保存按钮',
    cancelBtn: '取消按钮',
    buttonSetting: '按钮设置',
    more5Btn: '最多显示5个按钮',
    showBtns: '显示的按钮',
    hiddneBtns: '收起的按钮',
    dataSubmitCheck: '数据提交校验',
    submitCheckJuheInfo: '在满足条件公式下显示此消息，且提交失败',
    juheCheckInfo1: '公式内容必填',
    juheCheckInfo2: '在满足条件公式下，显示的消息内容必填',
    checkRepeatRoleSet: '查重规则设置',
    gobackHomepage: '返回首页',
    addLanguage: '添加语言',
    addLanguageMustFill: '添加的语种,列名称必填',
    picturedisplay: '图片展示',
    dongtaiField: '动态字段',
    currentDep: '当前部门及下级部门',
    principalSuperior: '负责人上级',
    principalDeartment: '负责人所属部门',
    areyouSureDel: '确定要删除该仪表盘数据吗?',

    // 2020-12-25
    NodeTimeLimit: '节点限时',
    NodeTimeLimitInfo:
      '为节点设置处理截止时间，并可自动提醒节点负责人处理待办，如果长时间不处理可自动提交或回退，避免流程停滞。',
    NodeTimeLimitInfo1: '节点超时触发超时处理方式',
    NodeTimeLimitSet: '节点限时设置',
    emailRemind: '邮件提醒',
    emailRemindInfo:
      '发件人为审批单的申请人，申请人需绑定邮件才可以使用该功能，若未绑定则邮件不会发送',
    emailRemindInfo1:
      '发件人为当前模块的负责人，负责人需绑定邮件才可以使用该功能，若未绑定则邮件不会发送',
    emailRemindNodePer: '邮件提醒节点审批人、抄送人',
    emailRemindNodePer1: '邮件提醒节点执行人',
    emailTemplateSet: '邮件模板设置',
    nodeEndtime: '节点审批截止时间',
    flowToCurrentNode: '流程到达该节点',
    PostTimeout: '后超时',
    TimeoutProcessingMode: '超时处理方式',
    AddProcessingMethod: '添加处理方式',
    ProcessingMethod: '处理方式',
    autoRemindTime: '自动提醒时间',
    Reminder: '提醒人',
    remindContent: '提醒内容',
    autoRejectTo: '自动驳回到',
    autoProcessingSet: '自动处理设置',
    TimeoutPerRemind: '超时后对指定的人员进行提醒',
    autoSubmitTime: '自动提交时间',
    autoRejectTime: '自动驳回到时间',
    nodeProcessingEndtime: '在节点处理截止时间',
    autoSubmitNextNode: '自动提交到下一审批节点',
    nodeReviewer: '节点审批人',
    PreviousNode: '上一个节点',
    ProcessSponsor: '流程发起人',
    customTime: '自定义时间',
    formDatemineFields: '根据表单内日期时间字段',
    autoRemind: '自动提醒',
    autoSubmit: '自动提交',
    autoReject: '自动驳回',
    atThatTime: '当时',
    autoRemindItemNotEmpty: '自动提醒时间不能为空',
    autoRemindTimeInteger: '自动提醒时间必须为正整数',
    nodeApprovalTimeRequired: '节点审批截止时间字段必填',
    remindContentRequired: '提醒内容必填',
    TimeoutReminderContent: '超时提醒内容',
    approvalTimeoutInfo: '审批限时即将超时',
    flowApprovalTimeout: '审批限时已超时',
    PleasePositiveInteger: '请输入正整数',
    mustYouApproval: '的申请需要您审批处理',
    creatingYibiaopan: '创建仪表盘',
    editYibiaopan: '编辑仪表盘',
    yibiaopanNameRequired: '仪表盘名称必填',
    LimitSettings: '限制设置',
    PhotoUploadOnly: '仅允许拍照上传',
    listDetailEditSet: '列表编辑和详情编辑设置',
    listDetailEditSetInfo:
      '用于对列表编辑和详情编辑功能的开关，关闭后将不可在列表或详情对单个字段进行编辑，只能点击编辑按钮进行编辑',
    submitApproval: '单据提交即提审',
    submitApprovalDesc:
      '开启：单据保存后直接进入审批，一旦开启【全局设置-自定义按钮-触发事件：发起审批】不再生效；关闭：单据无法进入审批，需要在【全局设置-自定义按钮-触发事件：发起审批】配置，保存-点击自定义按钮进入审批；',
    clickRightSetTabcontent: '点击在右侧设置添加页签内容',
    newBuildYibiaopan: '新建仪表盘',
    customBtnAfterClick: '在自定义按钮点击后',
    approvalStatusAfterUpdate: '在审批状态更新后',
    selectTargetCustombtn: '请选择需要触发的自定义按钮',
    selectTargetApprovalStatus: '请选择需要监听的审批状态',
    serialNumber: '编号',
    // 20210305
    signinpage: '签到成功显示信息',
    Industry_empty: '所属行业不能为空',
    appType_empty: '应用分类不能为空',
    subformSort: '子表单排序',
    subformSortDroggable: '子表单顺序上下拖动',

    // 2021-03-31
    formulaSubmitSaveInfo: '在满足条件公式时提交保存动作',
    moduleNameJudge: '名称仅为汉字、英文字母和数字',
    ListNumberSettings: '列表数量设置',
    listNumSwitch: '用于对列表显示数量的开关控制，勾选则可以选择该选项，不勾选则无该选项',
    Article100PerPage: '100条/页',
    Article500PerPage: '500条/页',
    SubformsRecordDynamics: '子表单记录动态',
    locationSetting: '定位设置',
    locationNearbyRange: '定位附近可选范围',
    subformDynamicTemplate: '订单明细子表单日志记录模板：',
    subformDynamicTip1: '在“订单明细中”新建了序号为【5】的产品编号【CP00001】',
    subformDynamicTip2:
      '在“订单明细中”中序号【5】产品编号为【CP00001】的【数量】从【52】改为【100】',
    subformDynamicTip3: '在“订单明细中”删除了序号为【5】的产品编号【CP00001】',
    subformDynamicTip4: '子表单字段唯一标识',
    subformDynamicTip5: '子表单记录动态字段包含：',
    subformNotSetFields: '子表单未设置字段',
    subformDynamicTip4required: '子表单字段唯一标识必填',
    subformDynamicTip5required: '子表单记录动态字段必填',
    UppercaseLettersNum: '大写字母+数字',
    LowercaseLettersNum: '小写字母+数字',
    UppercaseLowercaseLettersNum: '大小写字母+数字',
    AssociatedTarget: '关联目标',
    GetSssociatedModuleValue: '获取关联模块值',
    ComponentName: '组件名称',
    DynamicTimeNull: '动态时间为空值时显示',
    ReadFields: '读取字段',
    SubmitNum_1: '提交数量控制',
    SubmitNum_2: '关联模块提交数量控制',
    SubmitNum_3: '超过提交上限，提示：',
    SubmitNum_4: '提交数据有校验（未设置则为有效数据）',
    SignInShowInformation: '签到未预约显示信息',
    GetSssociationMapping: '通过关联映射获取',
    allApp: '所有应用',
    createAppFromTemplate: '从模板创建应用',
    allowSenderRevoke: '允许发起人撤销审批中的审批单',
    listPtimization: '列表性能优化',
    listPtimizationInfo: '用于对列表显示的总数和分页进行控制，在大数量的情况下优化性能',
    listPageSet: '列表分页',
    showBeforeOnly: '仅显示前',
    listGlobalSearch: '列表全局搜索',
    listGlobalSearchInfo:
      '开启后在列表显示全局搜索功能，可通过模糊搜索搜索文本、数字类型的组件（模块字段少于30个字段时开启，该功能性能损耗比较大，建议谨慎开启）',
    listDataShowControl: '列表数据显示控制',
    listDataShowControlInfo:
      '仅用于当前模块数据量大使用，勾选则全部子菜单中，列表的数据默认不显示，需要在列字段中进行筛选才会显示筛选后的数据。',
    checkListDataHiddle: '勾选即列表数据不显示',
    fieldIndex: '字段索引',
    fieldIndexInfo: '勾选后该字段在数据库中建立字段索引功能，优化数据库查询速度。',
    visiblePermission: '可见权限',
    editPermission: '编辑权限',
    approvalNodeLineError1: '开始节点不能直接连接结束节点',
    approvalNodeLineError2: '必须有连入线和连出线',
    approvalNodeLineError3: '没有',
    approvalNodeLineError4: '连出线',
    approvalNodeLineError5: '连入线',
    approvalNodeLineError6: '开始节点必须在第一个阶段中'
  }
}
